type StoreApi = {
  getState: () => any;
  dispatch: (action: any) => any;
};

let _store: StoreApi | null = null;

export const setRegisteredStore = (store: StoreApi): void => {
  _store = store;
};

export const getRegisteredStore = (): StoreApi => {
  if (!_store) throw new Error("Redux store has not been registered yet.");
  return _store;
};
